import * as React from 'react';

import type * as api from '@gitbook/api-client';
import * as analytics from '@gitbook/app-analytics/client';
import type { Space } from '@gitbook/app-database';

export function useSearchQueryAnalyticsEvent(
    query: string,
    context: {
        space?: Space;
        organization?: api.Organization | null;
    }
) {
    const { space, organization } = context;

    // Track when user is typing, debouncing it by 700ms.
    React.useEffect(() => {
        if (!query) {
            return;
        }

        const timeout = setTimeout(() => {
            const event = {
                type: 'search_type',
                query,
            } as analytics.ClientAnalyticsEvent;

            if (space) {
                analytics.logEvent(analytics.createSpaceEvent(space, event));
            } else if (organization) {
                analytics.logEvent(analytics.createOrgEvent(organization.id, event));
            } else {
                analytics.logEvent(event);
            }
        }, 700);

        return () => {
            clearTimeout(timeout);
        };
    }, [query]);
}
